import { guideSteps } from '@/mocks/filmData';

export default function GuideSteps() {
  return (
    <section id="guide" className="scroll-mt-20 bg-background-100">
      <div className="px-5 md:px-10 py-14 md:py-20">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-10 h-10 rounded-md bg-accent-100 text-accent-900 flex items-center justify-center">
            <i className="ri-route-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="text-xs font-medium tracking-widest text-accent-700 uppercase">Guide</span>
        </div>
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">查找与选择指南</h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-3xl leading-relaxed">
          按下面四个步骤走一遍，就能较清楚地确定自己需要哪种中文字幕或译制版本。
        </p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {guideSteps.map((step) => (
            <div key={step.step} className="relative rounded-lg bg-background-50 border border-background-200 p-5">
              <span className="font-heading text-3xl font-black text-primary-200">{step.step}</span>
              <h3 className="mt-2 font-heading font-semibold text-base text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}